module.exports = __webpack_public_path__ + "static/img/021_TO8_1496_og.2e12287.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/021_TO8_1496_og.jpg
// module id = JnZO
// module chunks = 0